import React from "react";

import { useWatch } from "react-hook-form";

import usePostHouseholdMember from "@fartherfinance/frontend/api/Households/hooks/usePostHouseholdMember";

import { useHouseholdContext } from "../../context";
import { formatAddHouseholdMemberResponse } from "../../utils";
import ButtonPrimary from "@src/multiCustodian/components/MUI/Button/Button";
import { useAdvisorPageInit } from "@src/multiCustodian/hooks/Advisor/useAdvisorPageInit";
import useStatusNotification from "@src/multiCustodian/hooks/useStatusNotification";
import { handleApiError } from "@src/utils/handleApiError";

import { HouseholdMemberRelationshipFormField } from "./HouseholdMemberRelationshipFormField";

import styles from "./HouseholdProfile.module.css";

export default function AddHouseholdMember() {
  const { form, householdId } = useHouseholdContext();
  const {
    control,
    formState: { isValid },
  } = form;

  const newHouseholdMember = useWatch({
    control,
    name: "newMember",
  });

  const { auth } = useAdvisorPageInit();

  const notify = useStatusNotification();

  const { mutateAsync: addHouseholdMember } = usePostHouseholdMember(auth!);

  const handleAddMemberClick = async () => {
    if (!householdId || !newHouseholdMember) {
      return;
    }

    try {
      if (!isValid) {
        throw new Error("Please fill out all required fields to proceed");
      }
      await addHouseholdMember({
        householdId,
        body: formatAddHouseholdMemberResponse(newHouseholdMember),
      });
    } catch (error) {
      handleApiError({
        error: error,
        errorMessage: "Error adding household member:",
        genericErrorMessage: "Error adding household member",
        notify,
      });
    }
  };

  return (
    <>
      <HouseholdMemberRelationshipFormField
        memberName="newMember.memberOption"
        relationshipName="newMember.relationshipOption"
        className={styles.memberFormField}
        memberlabel="New Member"
      />
      <ButtonPrimary
        text="Add Member"
        onClick={handleAddMemberClick}
        variant="outlined"
        buttonType="primary"
        className={styles.memberBtn}
      />
    </>
  );
}
